import { IconProps } from '@/root/shared-types/ui/ui-types'
import React, { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'

export const TrashBinIcon: FC<IconProps> = ({ width = 15, height = 16, ...rest }) => (
  <Icon type="TrashBin" width={width} height={height} alt="trash bin" {...rest} />
)
